/* eslint-disable camelcase */
export default {
  data () {
    return {
    }
  },
  watch: {
  },
  created () {
    console.log('[validity.js] mixins created')
  },
  methods: {
    validEmail (p_email) {
      var re = /\S+@\S+\.\S+/
      return re.test(String(p_email).toLowerCase())
    },
    validTelephone (p_phone_number) {
      var re = /^[+0-9]*$/
      return re.test(String(p_phone_number))
    },
    validNumeric (p_value) {
      return /^\d+$/.test(p_value)
    },
    validBirtNr (p_value) {
      // https://www.cssz.cz/standardni-kontrola-rodneho-cisla-a-evidencniho-cisla-pojistence
      if (this.validNumeric(p_value) === false) {
        return {status: false, err_code: 1, err_msg: 'Rodné číslo uvádějte bez lomítka, bez mezer a pouze čísla.'}
      }
      if (p_value.toString().length < 9) {
        return {status: false, err_code: 2, err_msg: 'Rodné číslo je kratší, než 9 znaků.'}
      }
      if (p_value.toString().length > 10) {
        return {status: false, err_code: 3, err_msg: 'Rodné číslo je delší, než 10 znaků.'}
      }
      // ---
      let year = p_value.toString()[0] + p_value.toString()[1]
      let month = p_value.toString()[2] + p_value.toString()[3]
      let day = p_value.toString()[4] + p_value.toString()[5]
      let ext = p_value.toString().substring(6) // posledne troj alebo stvor cislie
      let sex = 'man'
      // ---
      if (p_value.toString().length === 9 && ext === '000') {
        return {status: false, err_code: 4, err_msg: 'Koncovka rodného čísla 000 je nepřípustná.'}
      }
      if (month > 50) {
        sex = 'woman'
        month = month - 50 // skutocny mesiac zeny
      }
      if (month > 20) {
        // RC+ = TRUE
        month = month - 20
      }
      if (day > 40) {
        // EČP = TRUE
        day = day - 20
      }
      // vypocitaj datum narodenia
      let date_of_birth = this.$moment(`${year}/${month}/${day}`, 'YY/MM/DD')
      if (this.$moment(date_of_birth).isAfter(new Date())) { // ak je datum vacsi ako sucasny datum (stava sa to pri rodnych cisla zacinajucich 68 a nizsie)
        date_of_birth = this.$moment(date_of_birth).subtract(100, 'year')
      }

      // --- ak je vsetko OK, vysledok bude ---
      return {
        status: true,
        date_of_birth: new Date(date_of_birth),
        sex: sex
      }
    },
    validBirtDate (p_value) {
      let date = this.$moment(p_value)
      return date.isValid()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/HMEmployeeForm/mixins/validity.js